const aaa = [
	{
		path: "pethouse",
		component: () => import("@/views/huotiguanli/petHouse/pethouse.vue"),
		meta:{title:'宠物房间'},
	},
  
    {
		path: "houseLog",
		component: () => import("@/views/huotiguanli/petHouse/houseLog.vue"),
		meta:{title:'房间日志'},
	},
]
export default aaa;